<div id="fxRateLineChart" class="container"></div>
